import { Button, Dialog, TextField } from '@material-ui/core';
import React from 'react';
import styles from './ProductTypeDialog.module.css';
import Divider from 'components/common/Divider/Divider';
import { Formik } from 'formik';
import productTypeValidator from './ValidationSchema';
import { useTranslation } from 'react-i18next';

const ProductTypeDialog = ({ open, onClose, onSubmit, selectedEdit, edit }) => {
  const { t } = useTranslation();
  const initialValues = {
    name: edit?.name ?? '',
    description: edit?.description ?? '',
    category: edit?.category ?? ''
  };

  return (
    <Dialog open={open} onClose={onClose} className={styles.dialog}>
      <h3 className={styles.dialogH3}>{t('templates.addNewProduct')}</h3>
      <Divider isHorizontal={true} />
      <Formik
        validationSchema={productTypeValidator}
        validate={false}
        initialValues={initialValues}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          onSubmit(
            edit
              ? { ...edit, name: values?.name, description: values?.description, category: values?.category }
              : {
                  name: values?.name,
                  description: values?.description,
                  compatibleGroup: selectedEdit.compatibleGroup,
                  category: 'product',
                  priority: 2,
                  unitPrice: {
                    netAmount: 0,
                    grossAmount: 0,
                    vatAmount: 0,
                    taxRate: 0,
                    currency: 'HUF'
                  },
                  enabled: true
                }
          );
          setSubmitting(false);
          resetForm();
        }}>
        {({ values, handleChange, handleSubmit, errors, touched }) => (
          <form className={styles.dialogContainer}>
            <TextField
              name='name'
              variant='outlined'
              label={t('common.name')}
              size='small'
              value={values.name}
              onChange={handleChange}
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
            />
            <TextField
              name='description'
              variant='outlined'
              label={t('common.description')}
              size='small'
              value={values.description}
              onChange={handleChange}
              error={touched.description && Boolean(errors.description)}
              helperText={touched.description && errors.description}
            />
            <Button className={styles.buttonRed} type='submit' onClick={handleSubmit}>
              {edit?.name ? t('templates.saveProduct') : t('templates.createProduct')}
            </Button>
            <Button className={styles.buttonDark} onClick={onClose}>
              {t('common.cancel')}
            </Button>
          </form>
        )}
      </Formik>
    </Dialog>
  );
};

export default ProductTypeDialog;
